import { EventItem, EventItemKeyElements } from '../../data-types/sports/sportsInterfaces';
import { store } from '../store';
import {
  DELETE_SPORTSBOOK_EVENT,
  RESET_SPORTSBOOK_EVENTS,
  SET_SPORTSBOOK_EVENTS,
  SportsbookEventsState,
  UPDATE_SPORTSBOOK_EVENT,
} from '../types/sportsbookEventsType';

export const updateSportsbookEventItem = (meta: EventItem) => {
  store.dispatch({
    meta,
    type: UPDATE_SPORTSBOOK_EVENT,
  });
};

export const deleteSportsbookEventItem = (meta: EventItemKeyElements) => {
  store.dispatch({
    meta,
    type: DELETE_SPORTSBOOK_EVENT,
  });
};

export const resetSportsbookEvents = () => {
  store.dispatch({
    type: RESET_SPORTSBOOK_EVENTS,
  });
};

export const setSportsbookEvents = (meta: SportsbookEventsState) => {
  store.dispatch({
    meta,
    type: SET_SPORTSBOOK_EVENTS,
  });
};
